export enum ParentCompanyEnum {
  InstalcoSE = 1,
  InstalcoNO = 32,
  InstalcoMother = 1 || 32,
  // InstalcoFI = 0;
}
